import React from 'react';
import {
  EVBox, EVTypography,
} from '@eagleview/ev-comp-library';
import { SIGNUP_URL } from 'constants/AppConstants';
import useStyles from '../Authorize.style';

const AutoProvisionSignUp = () => {
  const classes = useStyles();
  return (
    <>
      <EVBox className={classes.autoProvisionBox}>
        <EVBox className={classes.autoProvisionMsg}>
          <EVTypography className={classes.msgStyle}>
            Oops!
          </EVTypography>
          <EVTypography className={classes.msgStyle}>
            It looks like you have not signed up for this application.
          </EVTypography>
          <EVTypography className={classes.msgStyle}>
            Please use this
            {' '}
            <a href={SIGNUP_URL} style={{ color: '#007CAD', fontWeight: '600', textDecoration: 'none' }}>sign up</a>
            {' '}
            link to register.
          </EVTypography>
          <EVTypography className={classes.msgStyle}>
            For any queries, reach out to our Support.
          </EVTypography>
        </EVBox>
      </EVBox>
    </>
  );
};

export default AutoProvisionSignUp;
